<div class="as">
  <!-- Header -->
  <div class="as-header">
    <div>
      <h1 class="as-title">Soporte</h1>
      <p class="as-lead">Tickets de todos los negocios. Cada respuesta le llega al usuario por correo.</p>
    </div>
    <label class="as-search">
      <span class="sr-only">Buscar tickets</span>
      <svg class="as-search__icon" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
      <input type="search" class="as-search__input" placeholder="Número, asunto, correo o negocio"
        [ngModel]="search()" (ngModelChange)="onSearch($event)" />
    </label>
  </div>

  <div class="as-tabs" role="group" aria-label="Filtrar tickets">
    @for (f of filters; track f.value) {
      <button type="button" class="as-tab" [attr.aria-pressed]="filter() === f.value" (click)="filter.set(f.value)">
        {{ f.label }} <span class="as-tab__count">{{ counts()[f.value] }}</span>
      </button>
    }
  </div>

  <div class="as-split" [class.as-split--open]="!!selected()">
    <!-- Inbox -->
    <section class="as-inbox" aria-label="Tickets">
      @if (!loaded()) {
        <ul class="as-list" role="status" aria-label="Cargando tickets">
          @for (i of [1, 2, 3, 4]; track i) {
            <li class="as-row as-row--skeleton animate-pulse">
              <span class="h-3 w-28 rounded bg-gray-200 dark:bg-gray-800"></span>
              <span class="h-4 w-56 max-w-full rounded bg-gray-200 dark:bg-gray-800"></span>
            </li>
          }
        </ul>
      } @else if (visibleTickets().length === 0) {
        <p class="as-empty">{{ emptyText() }}</p>
      } @else {
        <ul class="as-list" [class.opacity-60]="loading()">
          @for (ticket of visibleTickets(); track ticket.supportTicketId) {
            <li>
              <button type="button" class="as-row" [attr.aria-current]="selectedId() === ticket.supportTicketId ? 'true' : null"
                [attr.data-impact]="ticket.impact" (click)="select(ticket)">
                <span class="as-row__top">
                  <span class="as-code">{{ code(ticket.ticketNumber) }}</span>
                  <span class="as-pill" [attr.data-status]="ticket.status">{{ statusLabel(ticket.status) }}</span>
                  @if (isNew(ticket)) {
                    <span class="as-tag as-tag--new">Nuevo</span>
                  } @else if (userReplied(ticket)) {
                    <span class="as-tag as-tag--reply">Respondió</span>
                  }
                  <span class="as-row__time">{{ lastActivity(ticket) }}</span>
                </span>
                <span class="as-row__subject">{{ ticket.subject }}</span>
                <span class="as-row__who">
                  <span>{{ ticket.businessName || 'Sin negocio' }}</span>
                  <span class="as-row__sep" aria-hidden="true">/</span>
                  <span>{{ ticket.userName || ticket.userEmail }}</span>
                </span>
              </button>
            </li>
          }
        </ul>
      }
    </section>

    <!-- Ticket -->
    <section class="as-detail" aria-live="polite">
      @if (selected(); as ticket) {
        <div class="as-detail__head">
          <button type="button" class="as-back" (click)="closeDetail()">
            <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
            </svg>
            Tickets
          </button>
          <p class="as-detail__meta">
            <span class="as-code">{{ code(ticket.ticketNumber) }}</span>
            <span>Enviado el {{ ticket.createdAt | date: "d MMM y, h:mm a" }}</span>
          </p>
          <h2 class="as-detail__title">{{ ticket.subject }}</h2>
        </div>

        <!-- Status -->
        <div class="as-status" role="group" aria-label="Estado del ticket">
          @for (opt of statusOptions; track opt.value) {
            <button type="button" class="as-status__btn" [attr.data-status]="opt.value"
              [attr.aria-pressed]="ticket.status === opt.value" [disabled]="changingStatus()"
              (click)="changeStatus(ticket, opt.value)">
              {{ opt.label }}
            </button>
          }
        </div>

        <dl class="as-facts">
          <div>
            <dt>Negocio</dt>
            <dd>{{ ticket.businessName || 'Sin negocio' }}</dd>
          </div>
          <div>
            <dt>Usuario</dt>
            <dd>
              {{ ticket.userName }}
              <a class="as-link" [href]="'mailto:' + ticket.userEmail">{{ ticket.userEmail }}</a>
              @if (ticket.contactPhone) {
                <a class="as-link" [href]="'tel:' + ticket.contactPhone">{{ ticket.contactPhone }}</a>
              }
            </dd>
          </div>
          <div>
            <dt>Área</dt>
            <dd>{{ categoryLabel(ticket.category) }}</dd>
          </div>
          <div>
            <dt>Impacto</dt>
            <dd><span class="as-impact" [attr.data-impact]="ticket.impact">{{ impactLabel(ticket.impact) }}</span></dd>
          </div>
        </dl>

        <section aria-labelledby="as-original">
          <h3 id="as-original" class="as-subtitle">Lo que reportó</h3>
          <p class="as-original">{{ ticket.description }}</p>
        </section>

        <section aria-labelledby="as-convo">
          <h3 id="as-convo" class="as-subtitle">Conversación</h3>
          <app-support-thread [messages]="messages()" [loading]="messagesLoading()" viewer="support"
            emptyText="Nadie ha respondido todavía." />
        </section>

        <form class="as-reply" (ngSubmit)="sendReply(ticket)">
          <label for="as-reply-box" class="as-subtitle">Responder</label>
          <textarea id="as-reply-box" name="reply" rows="4" class="as-reply__input" [maxlength]="replyMax"
            placeholder="Escribe la respuesta. El usuario la verá aquí y le llegará por correo."
            [ngModel]="replyText()" (ngModelChange)="replyText.set($event)"></textarea>

          <fieldset class="as-after">
            <legend class="as-after__legend">Después de enviar</legend>
            <div class="as-after__options">
              @for (opt of replyStatusOptions; track opt.value) {
                <label class="as-after__opt">
                  <input type="radio" name="replyStatus" class="sr-only" [value]="opt.value"
                    [ngModel]="replyStatus()" (ngModelChange)="replyStatus.set($event)" />
                  <span class="as-after__box">
                    <span class="as-after__label">{{ opt.label }}</span>
                    <span class="as-after__hint">{{ opt.hint }}</span>
                  </span>
                </label>
              }
            </div>
          </fieldset>

          <div class="flex justify-end">
            <button type="submit" class="as-btn as-btn--primary" [disabled]="!replyText().trim() || sending()">
              {{ sending() ? 'Enviando…' : 'Enviar respuesta' }}
            </button>
          </div>
        </form>
      } @else {
        <div class="as-placeholder">
          <p>Elige un ticket para ver la conversación y responder.</p>
        </div>
      }
    </section>
  </div>
</div>
